module.exports = __webpack_public_path__ + "img/26_fineStaff_smm.85569105.png";